import dialog from "./dialog";
import overlay from "./overlay";
import search from "./search";
import wrapper from "./wrapper";

export default `
  ${dialog}
  ${overlay}
  ${search}
  ${wrapper}
`;
